import { CommercialMetricsConfig } from '@tenants';

//FIXME: Use Growthbook to get the correct values
export const metricsConfig: CommercialMetricsConfig = {
  metrics: [
    {
      value: '$54.1B',
      label: 'Q3 Sales Volume',
    },
    {
      value: '$1.3B',
      label: 'Q3 Revenue',
    },
    {
      value: '$3.5M',
      label: 'Q3 Net Income',
    },
    {
      value: '122K',
      label: 'Q3 Transactions',
    },
  ],
  backgroundVideo: {
    src: '/next/assets/videos/commercial/metrics-background.webm',
    type: 'video/webm',
  },
  logo: {
    src: '/next/assets/images/exp-commercial/eXp-World-Holdings-White.svg',
    alt: 'eXp Logo',
    width: 188,
    height: 40,
  },
};